/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style2 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

require('./index.less');

var _config = require('util/config');

var _tool = require('util/tool');

var _premissionAuth = require('util/premissionAuth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header(props, context) {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props, context));

    _this.state = {
      userName: window.localStorage.getItem('userName'),
      link: process.env.CUS_NODE_ENV === 'production' ? '//agent.ant.chargerlink.com' : '//test-cloud.chargerlink.com'
    };
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleLogin();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.state = {
        userName: window.localStorage.getItem('userName')
      };
    }
  }, {
    key: 'handleLogin',
    value: function handleLogin() {
      if ((0, _premissionAuth.getToken)()) {}
    }
  }, {
    key: 'handleQuit',
    value: function handleQuit() {
      var _this2 = this;

      (0, _tool.http)(_config.apiJson.logout, {}).then(function (res) {
        window.localStorage.removeItem('userName');
        window.localStorage.removeItem('token');
        _message2.default.success('\u9000\u51FA\u6210\u529F');
        _this2.setState({
          userName: ''
        });
        setTimeout(function () {
          _this2.props.router.push({
            pathname: '/login'
          });
        }, 200);
      }).catch(function (res) {
        var msg = !res.errmsg ? '' + res : res.errmsg;
        _message2.default.error(msg);
      });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex() {
      this.props.router.push({
        pathname: '/'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          userName = _state.userName,
          link = _state.link;

      return (0, _jsx3.default)('div', {
        className: 'cp-header'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'inner-header'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'header-cont'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'header-cont-left',
        onClick: this.goToIndex.bind(this)
      }, void 0, (0, _jsx3.default)('img', {
        src: require('./logo.png'),
        alt: ''
      }), '\u731B\u72B8\u7535\u52A8-\u8BBE\u5907\u7BA1\u7406\u5E73\u53F0'), (0, _jsx3.default)('div', {
        className: 'header-cont-right'
      }, void 0, userName ? (0, _jsx3.default)('div', {
        className: 'cont-user'
      }, void 0, (0, _jsx3.default)('div', {}, void 0, userName), (0, _jsx3.default)('div', {
        className: 'user-handle',
        onClick: this.handleQuit.bind(this)
      }, void 0, '\u9000\u51FA')) : ''))));
    }
  }]);
  return Header;
}(_react.Component);

exports.default = Header;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/components/header/index.jsx
// module id = 402
// module chunks = 0